module.exports = __webpack_public_path__ + "img/cube.be187421.svg";